<template>
  <v-row class="my-6" justify="center" no-gutters>
    <v-card elevation="8" shaped tile class="col-10">
      <v-card-title>
        <v-card-title>{{
          is_edit_mode ? "Company Setup" : "Company Setup"
        }}</v-card-title>
        <v-tooltip bottom  v-if="!is_edit_mode">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              color="primary"
              dark
              v-bind="attrs"
              v-on="on"
              size="35"
              @click="opendEditPopup()"
            >
              mdi-pencil-box-outline
            </v-icon>
          </template>
          <span>Company Detail</span>
        </v-tooltip>
      </v-card-title>
      <v-card-text>
    
        <v-form :readonly="!is_edit_mode">
          <v-row dense class="mb-1">
            <v-col cols="2">
              <v-text-field
                label="Name"
                dense
                autofocus
                v-model="form_data.name"
              ></v-text-field>
            </v-col>
        
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions v-if="is_edit_mode">
        <v-btn color="error" :disabled="loading" @click="is_edit_mode = false"
          >Cancel</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="AddCompanyDetail()" :loading="loading">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-row>
</template>

<script>
import axios from "../../plugins/axios";
import {  mapMutations } from "vuex";
export default {
  name: "UserEdit",
  data() {
    return {
      loading: false,
      is_edit_mode: false,
      form_data: {
        name:'',
      },
      form_error: {},
    };
  },
  computed: {
  },
  methods: {
    ...mapMutations("utils", ["setAlert"]),
    AddCompanyDetail() {
      this.loading = true;
      this.form_error = {};
      let _self = this;
      let serverData = JSON.parse(JSON.stringify(this._data.form_data));
      axios
        .post("edit_company_detail", serverData)
        .then(function (res) {
          let data = res.data;
          if (!data.status) {
            for (let key in data.errors) {
              _self.form_error[key] = data.errors[key][0];
            }
          } else {
            _self.loading = false;
             _self.setAlert({
              show: true,
              variant: "primary",
              message: "Company Detail updated successfully!",
              dismissCountDown: 0
            });
            _self.is_edit_mode = false;
          }
     
        })
        .catch(function (error) {
          console.log("FAILURE!!", error);
          _self.loading = false;
        });
    },

    getCompanyDetail() {
      this.loading = true;
      let _self = this;
      axios.get("get_company_detail").then(function (res) {
        if (res.data.status) {
        let data = res.data.data;
        _self.form_data.name=data.value['name'];
        _self.loading = false;
        }
      });
    },
    opendEditPopup() {
      this.is_edit_mode = true;
    },
  },
  mounted: function () {
      this.getCompanyDetail();
  },
};
</script>
<style scoped>
.display-sign {
  padding: 8px 16px;
  border: solid 1px;
  height: 100px;
}
.update-sign {
  width: "100%";
  padding: 8px 16px;
  border: solid 1px;
}
</style>